import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import './DefineNetworkStep';
import TextInput from '../../../../Shared/TextInput/TextInput';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {
  changeHandler,
  validateHandler,
  clearIsValid,
  setNetworkDefinitionProcessing,
  setNextWizardStep,
} from '../../routerActivationWizardBlockSlice';
import gaParams from '../../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../../utilities/analytics/tracking';

const DefineNetworkStep = (props) => {
  useEffect(() => {
    props.setNetworkDefinitionProcessing(false);
  }, []);

  useEffect(() => {
    if (!props.networkDefinitionProcessing) {
      gaEvent(
        gaParams.ROUTER_ACTIVATION_WIZARD_DEFINE_NETWORK_STEP_PHASE_1_DISPLAY.category,
        gaParams.ROUTER_ACTIVATION_WIZARD_DEFINE_NETWORK_STEP_PHASE_1_DISPLAY.eventType,
        gaParams.ROUTER_ACTIVATION_WIZARD_DEFINE_NETWORK_STEP_PHASE_1_DISPLAY.eventParams,
      );
    } else {
      gaEvent(
        gaParams.ROUTER_ACTIVATION_WIZARD_DEFINE_NETWORK_STEP_PHASE_2_DISPLAY.category,
        gaParams.ROUTER_ACTIVATION_WIZARD_DEFINE_NETWORK_STEP_PHASE_2_DISPLAY.eventType,
        gaParams.ROUTER_ACTIVATION_WIZARD_DEFINE_NETWORK_STEP_PHASE_2_DISPLAY.eventParams,
      );
    }
  }, [props.networkDefinitionProcessing]);

  useEffect(() => {
    async function setNextStep() {
      var stepData = {
        network: props.form.network,
        netpassword: props.form.netPassword,
      };

      var obj = {
        RequestId: props.RequestId,
        Step: props.Step,
        CurrentStep: props.CurrentStep,
        StepData: stepData,
      };

      props.setNetworkDefinitionProcessing(true);
      await props.setNextWizardStep(obj);
    }
    if (props.form.valid !== '') {
      if (props.form.valid) setNextStep();
    }
  });

  async function sendBtn() {
    gaEvent(
      gaParams.ROUTER_ACTIVATION_WIZARD_DEFINE_NETWORK_STEP_PHASE_1_CLICK_UPDATE_BUTTON.category,
      gaParams.ROUTER_ACTIVATION_WIZARD_DEFINE_NETWORK_STEP_PHASE_1_CLICK_UPDATE_BUTTON.eventType,
      gaParams.ROUTER_ACTIVATION_WIZARD_DEFINE_NETWORK_STEP_PHASE_1_CLICK_UPDATE_BUTTON.eventParams,
    );

    props.validateHandler(props.form);
  }

  const view = !props.networkDefinitionProcessing ? (
    <div>
      <div className='define-network-step-rectangle'>
        <TextInput
          error={props.form.errors.network}
          onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
          value={props.form.network}
          name='network'
          type='text'
          placeholder='שם רשת אלחוטית'
          required={true}
        />
        <div style={{display: 'flex'}}>
          <Image className='info-icon' src={require('../../images/info-icon/info-icon.svg')} />
          <span className='define-network-step-text-small'>אפשר להזין את פרטי הרשת הקיימת או להזין אחת חדשה</span>
        </div>
        <TextInput
          error={props.form.errors.netPassword}
          onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
          value={props.form.netPassword}
          name='netPassword'
          type='text'
          placeholder='סיסמאת רשת אלחוטית'
          required={true}
        />
        <div style={{display: 'flex'}}>
          <Image className='info-icon' src={require('../../images/info-icon/info-icon.svg')} />
          <span className='define-network-step-text-small'>8 תווים לפחות. אפשר להזין סיסמא קיימת או לבחור חדשה.</span>
        </div>
      </div>
      <div className='define-network-step-attention-section'>
        <div style={{display: 'flex'}}>
          <Image className='info-icon' src={require('../../images/i-icon/i-icon.svg')} />
          <div className='define-network-step-text-small'>
            אם בחרתם שם רשת וסיסמא חדשים,
            <br />
            אל תשכחו לחבר את כל המכשירים האלחוטיים
            <br />
            לרשת החדשה
          </div>
        </div>
      </div>
      <div style={{textAlign: 'center', marginTop: '25px'}}>
        <BtnSubmit className='update-btn' onclick={sendBtn} text='אפשר לעדכן'></BtnSubmit>
      </div>
    </div>
  ) : (
    <div className='define-network-step-text'>
      מעדכנים פרטים.
      <br />
      זה יכול לקחת כמה דקות...
    </div>
  );

  return (
    <div className='define-network-step'>
      <div className='define-network-step-top-circle'>3</div>
      <div className='define-network-step-title'>כמעט סיימנו!</div>
      <div className='define-network-step-text'>
        נשאר רק להגדיר את הרשת האלחוטית
        <br />
        שלכם והסופר ראוטר מחובר
      </div>
      {view}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    form: state.RouterActivationWizardBlock.form,
    RequestId: state.RouterActivationWizardBlock.wizardRequestId,
    CurrentStep: state.RouterActivationWizardBlock.currentStep,
    Step: state.RouterActivationWizardBlock.step,
    networkDefinitionProcessing: state.RouterActivationWizardBlock.networkDefinitionProcessing,
  };
};

const mapDispatchToProps = {
  changeHandler,
  validateHandler,
  clearIsValid,
  setNetworkDefinitionProcessing,
  setNextWizardStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(DefineNetworkStep);
